import { useContext, useEffect, useState } from "react";
import ModalAutoTSuccess from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoTSuccess/ModalAutoTSucces";
import { wsGetDemora } from "_+_Portal/_-_Autocheckin/context/action/demora";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsPostAsignarPresente } from "_+_Portal/_-_Autocheckin/context/action/presente";
import { setTurnosRecepcionados } from "_+_Portal/_-_Autocheckin/context/action/turnosRecepcionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";

const TurnoProximo = ({ setTurnoActual, turnoActual, setLoading }) => {
  // -------------------------  context ----------------------------
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    turnosRecepcionadosDispatch,
    presenteDispatch,
    ubicacionState,
    demoraDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
    pasoState,
  } = useContext(AutocheckContext);

  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];
  const actual = turnoActual + 1;
  const turnosLenAll = listTurnosSeleccionado.length;
  let parsedConfig = {};
  try { parsedConfig = JSON.parse(localStorage.getItem("config")) || {}; } catch (e) { parsedConfig = {}; }
  let sectorTurno = parsedConfig.sectorTurno;
  let opcFilaVirtual = parsedConfig.opcFilaVirtual;
  const [showComponent, setShowComponent] = useState(false);
  // -------------------------  constantes ----------------------------

  const callBack = (origen) => {
    if (origen === "proximoTurno") {
      if (pasoState.circuito === "labo") {
        setPaso("ResumenLabo")(pasoDispatch);
      } else {
        setPaso("Resumen")(pasoDispatch);
      }
    } else {
      if (!ubicacionState?.ubicacion?.data) {
        setPaso("TurnosRecepionados")(pasoDispatch);
      } else {
        if (opcFilaVirtual) {
          if (ubicacionState?.ubicacion?.data) {
            wsGetDemora(
              turno?.idEspecialidad,
              turno?.idMedico,
              turno?.idturno,
              false,
              (isCorrect, demora) => irAFilaVirtual(isCorrect, demora)
            )(demoraDispatch);
          } else {
            setPaso("FilaVirtualCasa")(pasoDispatch);
          }
        } else {
          setPaso("TurnosRecepionados")(pasoDispatch);
        }
      }
    }
  };

  const irAFilaVirtual = (isCorrect, demora) => {
    let toleranciaDemoraMinutos =
      textosAutoCheckinState.textosAutoCheckin?.data?.colaVirtualPregunta?.orden ?? 0;
    if (isCorrect) {
      if (demora.demora > toleranciaDemoraMinutos) {
        setPaso("FilaVirtual")(pasoDispatch);
      } else {
        setPaso("TurnosRecepionados")(pasoDispatch);
      }
    }
  };

  const proximoTurno = () => {
    setTurnosRecepcionados(turno)(turnosRecepcionadosDispatch);
    setLoading("Cargando...");
    setPaso("Loading")(pasoDispatch);
    callBack("proximoTurno");
    setTurnoActual(turnoActual + 1);
  };

  const finzalizarRecepcion = () => {
    setTurnosRecepcionados(turno)(turnosRecepcionadosDispatch);
    setLoading("Cargando...");
    setPaso("Loading")(pasoDispatch);
    callBack("finzalizarRecepcion");
    setTurnoActual(0);
  };

  useEffect(() => {
    if (!turno) return;
    wsPostAsignarPresente(turno?.idturno, sectorTurno, (isCorrect) => {
      if (!isCorrect) {
        setLoading(true);
        const idTipoPuntoControl = 11;
        setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        setPaso("PuntoControl")(pasoDispatch);
      } else {
        setShowComponent(true);
      }
    })(presenteDispatch);
  }, []);

  if (!turno) return null;

  return (
    <>
      {showComponent ? (
        <ModalAutoTSuccess
          descripcion={`
        El turno ${actual} de ${turnosLenAll} ha sido recepcionado correctamente <br/>
        `}
          textBtn={
            actual === turnosLenAll
              ? `Finalizar la recepción`
              : `Continuar Recepción`
          }
          onClick={actual === turnosLenAll ? finzalizarRecepcion : proximoTurno}
        />
      ) : (
        <Loading
          dataLoading={true}
          descripcion="Cargando..."
          color={"c-white"}
        />
      )}
    </>
  );
};

export default TurnoProximo;
